import { useTonWallet } from "@tonconnect/ui-react";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import Btn from "../Btn/Btn";
import BlueDiagArrow from "../Icons/BlueDiagArrow";
import CircleLoading from "../Icons/CircleLoading";
import s from "./ApproveModalContent.module.scss";

export type ApproveModalContentProps = {
  title: string;
  subtitle: string;
  isButtonDisabled: boolean;
  primaryAction: () => void;
  secondaryAction: () => void;
  needToCallActionOnMount?: boolean;
};

export const ApproveModalContent: React.FC<ApproveModalContentProps> = observer(
  ({
    title,
    subtitle,
    isButtonDisabled,
    primaryAction,
    secondaryAction,
    needToCallActionOnMount = false,
  }) => {
    const wallet = useTonWallet();
    const [wasCalledOnMount, setWasCalledOnMount] = useState(false);

    useEffect(() => {
      if (wasCalledOnMount || !needToCallActionOnMount) return;

      const primaryActionCall = async () => {
        try {
          await primaryAction();
        } catch (error: any) {
          throw error;
        } finally {
          setWasCalledOnMount(true);
        }
      };
      primaryActionCall();
    }, [needToCallActionOnMount, wasCalledOnMount]);

    return (
      <div className={s.wrapper}>
        <div className={s.loading}>
          <CircleLoading />
        </div>
        <div className={s.title}>{title}</div>
        <div className={s.text}>{subtitle}</div>
        <Btn disabled={isButtonDisabled} onClick={primaryAction} height="56">
          Send transaction
        </Btn>
        <div className={s.go} onClick={secondaryAction}>
          Go to {wallet && wallet.device && wallet.device.appName}{" "}
          <BlueDiagArrow />
        </div>
      </div>
    );
  }
);
